export default __webpack_public_path__ + "static/iam_role_02-c5f567e0de7788ceb1ca6ece934d9334.png";